import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { LeistungseinheitPipe } from './leistungseinheit.pipe';

@NgModule({
    declarations: [
        LeistungseinheitPipe,
    ],
    exports: [
        LeistungseinheitPipe,
    ],
    providers: [
        DecimalPipe,
    ],
    imports: [
        CommonModule,
    ],
})
export class PipeModule {
}
